import React, { useState, useEffect } from 'react';
import useAxios from 'hooks/useAxios';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, IconButton, Tooltip, Stack, CircularProgress, useMediaQuery, useTheme } from '@mui/material';
import FireTruckIcon from '@mui/icons-material/FireTruck';
import { NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';

import Form from './Form';
import { toast } from 'react-toastify';

export default function DownloadReport({ filter, setExpanded }) {
  const theme = useTheme();
  const [{ error, isLoading }, getData] = useAxios();
  const { userToken } = useSelector((state) => state.auth);

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});

  const onClick = () => setOpen(true);
  const onClose = () => setOpen(false);
  const onChange = ({ formData }) => {
    const foramattedFormData = Object.fromEntries(Object.entries(formData).map(([key, value]) => [key, Number(value)]));
    setFormData(foramattedFormData);
  };

  const formatFilter = (filter) => {
    const formattedFilter = {};

    for (const key in filter) {
      if (filter.hasOwnProperty(key)) {
        if (filter[key]) {
          if (typeof filter[key] === 'string') {
            formattedFilter[key] = [filter[key]];
          } else {
            formattedFilter[key] = filter[key];
          }
        }
      }
    }

    return formattedFilter;
  };

  const getReports = async () => {
    // if (!filter?.vehicle_ids) {
    //   toast.error('ماشین مورد نظر را فیلتر کنید!');
    //   setExpanded(true);
    //   return;
    // }
    const formattedFilter = formatFilter(filter);
    const { response: data, error: downloadError } = await getData({
      method: 'POST',
      responseType: 'blob',
      url: 'https://core.satrapsazeh.ir/api/export-task-vehicles',
      data: {
        ...formData,
        ...formattedFilter,
      },
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    });

    if (data) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'satrap-truck.xlsx'); //Download file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (downloadError) {
      console.error('Download error:', downloadError);
      toast.error('مشکلی پیش آمده!');
    }
    onClose();
  };

  return (
    <>
      <Tooltip title="گزارش ماشین">
        <IconButton
          sx={{ bgcolor: 'success.lighter' }}
          size="small"
          color="success"
          onClick={onClick}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress color="success" size={25} /> : <FireTruckIcon />}
        </IconButton>
      </Tooltip>
      <NewDialog label="reportDownload" open={open} onClose={onClose} maxWidth="sm">
        <NewDialogTitle title="انتخاب ستون‌ها" onClose={onClose} />
        <NewDialogContent>
          <Stack p={1}>
            <Form formData={formData} onChange={onChange} />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button size="large" variant="contained" onClick={getReports} disabled={isLoading}>
            <FormattedMessage id="reportDownload" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
